<mat-card>
<mat-card-title>
<span>LP{{save.lp_number}}</span><span>{{save.amount | currency:'NGN':'symbol-narrow'}}</span>
</mat-card-title>
<mat-card-content><span>{{save.name}}</span><span></span></mat-card-content>
<mat-card-footer>
<span><button mat-button color="warn" (click)="deleteSave()">delete</button></span><span>{{save.createdAt |date:'medium' }}</span>
</mat-card-footer>
</mat-card>
